/**
 * 渠道结果表格列定义
 */

import React from 'react';
import { Space, Tag } from 'antd';
import { TruckOutlined, RocketOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { ChannelResult } from '../constants/pricingConstants';

export const getChannelResultColumns = (bestChannel: ChannelResult | null): ColumnsType<ChannelResult> => [
    {
        title: '物流渠道',
        dataIndex: 'channel',
        key: 'channel',
        render: (text, record) => (
            <Space>
                <TruckOutlined />
                {text}
                {bestChannel && record.key === bestChannel.key && (
                    <Tag color="success" icon={<RocketOutlined />}>推荐</Tag>
                )}
            </Space>
        )
    },
    {
        title: '头程(¥)',
        dataIndex: 'shippingCNY',
        key: 'shippingCNY',
        render: (v) => `¥${v.toFixed(2)}`
    },
    {
        title: '完税成本($)',
        dataIndex: 'landed',
        key: 'landed',
        render: (v) => `$${v.toFixed(2)}`
    },
    {
        title: '利润($)',
        dataIndex: 'profit',
        key: 'profit',
        render: (v) => (
            <span style={{ color: v > 0 ? '#52c41a' : '#f5222d', fontWeight: 600 }}>
                ${v.toFixed(2)}
            </span>
        )
    },
    {
        title: '利润率(%)',
        dataIndex: 'margin',
        key: 'margin',
        render: (v) => (
            <span style={{ color: v > 20 ? '#52c41a' : '#faad14', fontWeight: 600 }}>
                {v.toFixed(1)}%
            </span>
        )
    },
    {
        title: 'ROI(%)',
        dataIndex: 'roi',
        key: 'roi',
        render: (v) => `${v.toFixed(1)}%`
    }
];
